import React from 'react';

const BreakdownTab = ({ growthTable }) => {
  if (!growthTable || growthTable.length === 0) {
    return (
      <div className="breakdown-empty">
        <p>Generate a compound breakdown first using the <strong>Compound</strong> tab to see the growth table here.</p>
      </div>
    );
  }

  return (
    <div className="breakdown-wrapper">
      <h3>📊 Growth breakdown</h3>
      <div id="growthTable" className="growth-table-wrap">
        <table className="growth-table">
          <thead>
            <tr>
              <th>Month</th>
              <th>Interest</th>
              <th>Balance</th>
            </tr>
          </thead>
          <tbody>
            {growthTable.map((row) => (
              <tr key={row.month}>
                <td>{row.month}</td>
                <td>{row.interest.toFixed(2)}</td>
                <td>{row.balance.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BreakdownTab;
